import React, { useCallback, useMemo } from "react";
import { Grid } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { userProfileSchema } from "../../../../schemas/userProfile";
import UserProfileSidebar from "./UserProfileSidebar";
import UserProfileForm from "./UserProfileForm";
import { useQueryClient } from "@tanstack/react-query";
import useMutate from "../../../../hooks/useMutate";
import { updateUserDetails } from "../../../../services/apiUser";

function UserProfileContent({ profileData, userId, handleClose, onChangePassword }) {
  const queryClient = useQueryClient();

  const defaultValues = useMemo(() => ({
    first_name: profileData?.user?.first_name || "",
    last_name: profileData?.user?.last_name || "",
    email: profileData?.user?.email || "",
    team: profileData?.user?.team_id || "",
    isActive: profileData?.user?.active || false,
    worklogsRequired: profileData?.user?.cardlog_required || false,
    isSuperAdmin: profileData?.user?.role === "Super Admin",
  }), [profileData]);

  const methods = useForm({
    resolver: yupResolver(userProfileSchema),
    defaultValues,
  });

  const { mutate } = useMutate(updateUserDetails, ["users"],() => {}, () => {
    queryClient.invalidateQueries(["users", userId]);
    queryClient.invalidateQueries(["userProfile", userId]);
    handleClose();
  });

  const onSubmit = useCallback((formData) => {
    const obj = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      role: formData.isSuperAdmin ? "Super Admin" : "user",
      cardlog_required: formData.worklogsRequired,
      active: formData.isActive,
      ...(formData.email !== profileData.user.email && {
        email: formData.email,
      }),
      ...(formData.team && {
        team_id: formData.team,
      }),
    };
    mutate({ userId, data: obj });
  }, [mutate, profileData.user.email, userId]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container className="user-profile-cont">
          <UserProfileSidebar 
            profileData={profileData}
            onChangePassword={onChangePassword}
            userId={userId}
          />
          <UserProfileForm 
            profileData={profileData}
            userId={userId}
          />
        </Grid>
      </form>
    </FormProvider>
  );
}

export default React.memo(UserProfileContent); 